export const selectMultiplier = (state) => state.multiplier.value;